import { useMemo } from "react";
const useSafeDateString = (date)=>useMemo(()=>{
        if (!date) return;
        const time = date instanceof Date ? date.getTime() : NaN;
        if (Number.isNaN(time)) return;
        try {
            return new Date(time).toISOString();
        } catch  {
            return;
        }
    }, [
        date
    ]);
export { useSafeDateString };
